<div [formGroup]="form" *ngIf="field.editable">
  <input
    class="form-control"
    prefix="{{numberMaskPrefix}}"
    mask="separator"
    thousandSeparator=","
    [attr.disabled]="disabled ? '' : null"
    [formControlName]="field.alias"
    type="currency"
    [id]="'ba-'+ field.alias"
    [ngClass]="{'is-invalid':!control.valid && (control.touched || control.dirty)}"
  />
  <span
    class="invalid-feedback"
    *ngIf="control.hasError('max') && (control.touched || control.dirty)">
      Amount seems too high.
  </span>
</div>
<ng-container *ngIf="!field.editable && field.value">
  {{ field.value | currency }}
</ng-container>
